import React, {Component} from 'react';
import PropTypes from 'prop-types';

class TextAreaFoldout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFocused: false,
		};
	}

	onFocus() {
		if (!this.props.disabled) this.setState({isFocused: true});
	}

	onBlur() {
		if (this.props.onBlur) {
			this.props.onBlur(this.foldoutarea.value);
		}
		this.setState({isFocused: false});
	}

	onChange(e) {
		if (this.props.onChange) {
			this.props.onChange(e.target.value);
		}
	}

	render() {
		return (
			<div className="textarea-foldout">
				{this.props.hideLabel ? null : (
					<label id={'text-area-label'} className={'label'}>
						{this.props.label}
					</label>
				)}
				<input readOnly={this.props.disabled} onFocus={this.onFocus.bind(this)} value={this.props.value ? this.props.value : ''} ref={input => (this.textarea_input = input)} onChange={() => {}} placeholder={this.props.placeholder} />
				{this.state.isFocused ? (
					<textarea
						disabled={this.props.disabled}
						maxLength={this.props.maxChars || 999}
						className="foldout"
						defaultValue={this.props.value ? this.props.value : ''}
						rows={10}
						cols={this.props.numCols ? this.props.numCols : 40}
						onBlur={this.onBlur.bind(this)}
						autoFocus={true}
						onChange={this.onChange.bind(this)}
						ref={textarea => (this.foldoutarea = textarea)}
						placeholder={this.props.placeholder}
					/>
				) : null}
			</div>
		);
	}
}

TextAreaFoldout.propTypes = {
	value: PropTypes.string,
	maxChars: PropTypes.number,
};
export default TextAreaFoldout;
